var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovelUnit = function SvgMovelUnit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#movel-unit_svg__a)",
    d: "M16.586 5.174a9.92 9.92 0 0 1 9.728 0c3.013 1.701 4.886 4.854 4.886 8.285 0 4.294-2.095 8.233-4.109 11.048-2.031 2.841-4.103 4.708-4.304 4.886a2.015 2.015 0 0 1-2.676-.002c-.206-.183-2.274-2.049-4.302-4.884-2.013-2.815-4.109-6.754-4.109-11.048 0-3.43 1.873-6.583 4.886-8.285m1.278 2.264a7.32 7.32 0 0 1 7.172 0c2.215 1.251 3.564 3.55 3.564 6.02 0 3.492-1.73 6.89-3.623 9.537a30.3 30.3 0 0 1-3.527 4.09 30.3 30.3 0 0 1-3.526-4.09C16.03 20.347 14.3 16.95 14.3 13.459c0-2.471 1.35-4.77 3.564-6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#movel-unit_svg__b)",
    d: "M34.474 23.4H42.9a1.3 1.3 0 0 1 1.233.89l7.15 21.45a1.3 1.3 0 0 1-1.233 1.71H2.6a1.3 1.3 0 0 1-1.272-1.57l4.55-21.45A1.3 1.3 0 0 1 7.15 23.4h4.55a1.3 1.3 0 1 1 0 2.6H8.203l-.992 4.676 6.88.666.336-.702a1.3 1.3 0 0 1 2.408.968l11.25 1.088 4.057-6.695H31.2a1.3 1.3 0 1 1 0-2.6zm.708 2.6-4.226 6.974 13.776 1.333-2.769-8.306h-6.78Zm-8.593 9.164-10.937-1.059-5.14 10.746h10.206l5.87-9.687Zm-2.831 9.687 5.702-9.41 16.172 1.566 2.614 7.844zm-16.127 0 5.266-11.012-6.229-.603L4.205 44.85H7.63Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#movel-unit_svg__c)",
    d: "M16.9 13.65a4.55 4.55 0 1 1 9.1 0 4.55 4.55 0 0 1-9.1 0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#movel-unit_svg__d)",
    d: "M16.843 31.61a1.3 1.3 0 0 0-2.4-.995l-.72 1.566a1.3 1.3 0 0 0 1.053 1.837l11.808 1.169-6.226 10.29a1.3 1.3 0 0 0 1.112 1.974h28.58a1.3 1.3 0 0 0 0-2.6H23.776l6.1-10.082a1.3 1.3 0 0 0-.985-1.966z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "movel-unit_svg__a",
    x1: 21.45,
    x2: 21.45,
    y1: 29.9,
    y2: 3.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "movel-unit_svg__b",
    x1: 26.325,
    x2: 26.325,
    y1: 47.451,
    y2: 23.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "movel-unit_svg__c",
    x1: 21.45,
    x2: 21.45,
    y1: 18.2,
    y2: 9.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "movel-unit_svg__d",
    x1: 32.477,
    x2: 32.477,
    y1: 47.451,
    y2: 29.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgMovelUnit;